import React, { useState } from "react";
import { useWizard } from "../../../../components/wizard/WizardContext";
import SingleBulkSearchPanel from "../../../../components/SingleBulkSearchPanel/SingleBulkSearchPanel";
import {
  filterOutExcludedBUs,
  getBulkSearchFormFields,
  searchStudents,
  singleSearchParams,
  useAutoSelectStudentForRefundEdit,
} from "./constants";
import { useGetBUByBUType, useGetCourseIdsForBUAndTerm } from "../../../../views/pages/manage/edpOps/stockManagement/customhooks";
import { useSearchStudentsHandler } from "../../../studentTransfer/customHooks";
import RefundTrackerCard from "./RefundTrackerCard";
import ALoader from "../../../../views/pages/manage/common/a-loader";
import { getBulkOnlyFilters } from "../../../studentTransfer/components/utils";
import useCashierOfficeDropdown from "../../../../views/pages/manage/common/hook/useCashierOfficeDropdown";


const SearchStudent = () => {

  const { dropdowns, values } = useWizard();
  const { searchHandler } = useSearchStudentsHandler();

  const [filterForm, setFilterForm] = useState(
    getBulkOnlyFilters(values?.searchStudentsFilters ?? {})
  );

  const [courseIdDropdown, courseIdDropdownLoading] =
    useGetCourseIdsForBUAndTerm({
      businessArea: filterForm?.businessArea,
      term: filterForm?.term,
    });

  const [buDropdown, buDropdownLoading] = useGetBUByBUType(filterForm?.branchType);
  
  
  const filterFormHandler = (key, val) => {
    setFilterForm((prev) => ({ ...prev, [key]: val }));
  };

  const {items : cashierOfficeDropdownData , disabled : cashierOfficeDropdownDisabled} = useCashierOfficeDropdown({businessArea : filterForm?.businessArea, formHandler : filterFormHandler })

  const studentSearchHandler = async (filters, offset = 0) => {
    searchHandler(filters, offset, true, 50, searchStudents);
  };


  const isSearchBtnDisabled = () => {
    const {branchType , businessArea, term , courseIds, cashierOffice} = filterForm;
    return (!branchType || !businessArea || !term || !courseIds?.length || !cashierOffice);
  }

  const {fetchingRefundDetails} = useAutoSelectStudentForRefundEdit();

  return (
    <div>
      {(dropdowns?.loading || values?.searchStudentsLoading || fetchingRefundDetails) && <ALoader position={"fixed"}/>}
       <SingleBulkSearchPanel
        panelHeading="Search students to create a refund"
        searchBtnTxt="Search"
        singleSearchParams={singleSearchParams}
        bulkSearchFormFields={getBulkSearchFormFields({
          ...dropdowns?.data,
          courseIdDropdown,
          courseIdDropdownLoading,
          buDropdown:filterOutExcludedBUs(buDropdown),
          buDropdownLoading,
          filterForm,
          setFilterForm,
          cashierOfficeDropdownData,
          cashierOfficeDropdownDisabled
        })}
        bulkSearchForm={filterForm}
        bulkSearchFormHandler={filterFormHandler}
        searchHandler={studentSearchHandler}
        isSearchBtnDisabled={isSearchBtnDisabled()}
      />
      <RefundTrackerCard/>
    </div>

  );

};


export default SearchStudent;
